import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  getOpcionMenu,
  getEstanciaActualGaTitle,
  setVisible
} from '../../modules/reducer'

import IconMark from './IconMark'

import MeasureWidth from './MeasureWidth'
import IconEuro from './IconEuro'
import { moving } from './MenuScroll'

//import ReactGA from 'react-ga'
import { gaEvent } from '../../Cookies'

const Frame = ({
  id,
  idAcabado,
  acabadoGaTitle,
  visible,
  padding,
  srcIcono,
  title,
  subtitle,
  precio,
  setVisible,
  estanciaGaTitle
}) => {
  const [width, setWidth] = useState(0)

  const onClick = e => {
    if (!moving) {
      gaEvent({
        category: 'Opción seleccionada',
        action: `${estanciaGaTitle} ${acabadoGaTitle}`,
        label: title
      })
      /*ReactGA.event({
        category: 'Opción seleccionada',
        action: `${titleAcabado}`,
        label: title,
        value: id
      })*/

      setVisible(idAcabado, id)
    }
  }

  const style = {
    padding: '5px 0 5px 0',
    cursor: 'pointer'
  }

  if (visible) {
    style.backgroundColor = '#eeeeee'
  }

  return (
    <div className="col-12 grid-noGutter" style={style} onClick={onClick}>
      <MeasureWidth setSize={setWidth} />
      <div
        className="grid-middle"
        style={{ position: 'relative', marginLeft: padding }}
      >
        <img
          alt=""
          src={srcIcono}
          style={{
            borderRadius: '50%',
            height: 70,
            width: 70
          }}
        />
        {visible ? <IconMark size={26} /> : null}
      </div>
      <div className="grid-middle-noGutter" style={{ width: width - 90 }}>
        <div className="col-7" style={{ paddingLeft: 20 }}>
          <div style={{ fontWeight: 500, whiteSpace: 'normal' }}>{title}</div>
          <div style={{ fontWeight: 300, whiteSpace: 'normal' }}>
            {subtitle}
          </div>
        </div>
        <div
          className="col-5"
          style={{ textAlign: 'right', paddingRight: padding / 2 }}
        >
          <IconEuro />
          <span style={{ paddingLeft: '1.5em' }}>{precio}</span>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const getO = getOpcionMenu(ownProps.id)

  return ({ reducer }, ownProps) => {
    const opcion = getO(reducer)

    return {
      srcIcono: opcion.srcIcono,
      title: opcion.title,
      subtitle: opcion.subtitle,
      precio: opcion.precio,
      estanciaGaTitle: getEstanciaActualGaTitle(reducer)
    }
  }
}

const mapDispatchToProps = { setVisible }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frame)
